import { applyMiddleware, compose, createStore, Middleware, Store } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { rootReducer, RootState } from 'src/reducers/RootReducer';
import { History, createBrowserHistory } from 'history';
import thunk from 'redux-thunk';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import { PersistConfig } from 'redux-persist/es/types';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';

/* tslint:disable no-any */
// TODO: Find a way to compose the typing of the StoreEnhancer with the reducers and middlewares in createStore
declare const window: Window & {
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any,
};
/* tslint:enable no-any */

export const history: History = createBrowserHistory();

const recoverState = (): RootState => ({} as RootState);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const routingMiddleWare: Middleware = routerMiddleware(history);

const persistConfig: PersistConfig = {
  key: 'root',
  whitelist: ['authentication'],
  storage: storage,
  stateReconciler: autoMergeLevel2 // see "Merge Process" section for details.
};

const persistedRootReducer = persistReducer(persistConfig, rootReducer);

export const store: Store<RootState> = createStore(
  persistedRootReducer,
  recoverState(),
  composeEnhancers(applyMiddleware(thunk, routingMiddleWare))
);

export const persistor = persistStore(store);


// WEBPACK FOOTER //
// ./src/store/index.tsx